import Svg, { Path } from "react-native-svg";
import type { SvgProps } from "react-native-svg";
import { memo } from "react";
const SvgIconPause = (props: SvgProps) => <Svg xmlns="http://www.w3.org/2000/svg" width={31} height={31} fill="none" viewBox="0 0 31 31" {...props}><Path fill="currentColor" d="M10.935 3.761h-5.87v23.478h5.87V3.761ZM25.935 3.761h-5.87v23.478h5.87V3.761Z" /></Svg>;
const Memo = memo(SvgIconPause);
export default Memo;